export const GET_FEATURED_CONTENTS = 'GET_FEATURED_CONTENTS';
export const GET_TODAY_CONTENTS = 'GET_TODAY_CONTENTS';
export const GET_AFTER_TOMORROW_CONTENTS = 'GET_AFTER_TOMORROW_CONTENTS';
export const GET_ALL_CONTENTS = 'GET_ALL_CONTENTS';
export const REQUEST_GET_ALL_CONTENTS = 'REQUEST_GET_ALL_CONTENTS';
export const GET_WEBINAR_CONTENTS = 'GET_WEBINAR_CONTENTS';
